/**
 * Spørringen til GET /api/chores/instances — foreldrekonsollens liste over
 * spredte kort (#159, steg 9b).
 *
 * `date` er en kalenderdag i Europe/Oslo (`YYYY-MM-DD`). Med den svarer
 * API-et bare med kort spredd den dagen, og uten tak på 50: én families kort
 * på én dag er få, og flisene «Oppgaver i dag» må telle alle. Uten `date` er
 * oppførselen som før (siste 50, alle dager).
 *
 * `status` og `memberId` valideres ikke her: et ukjent `status` har alltid
 * vært ignorert i stedet for avvist (se ruten), og det beholdes.
 */
import { z } from 'zod';

export const OsloDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD')
  // Avviser 2026-02-30 o.l.: regexen alene slipper gjennom datoer som ikke finnes.
  .refine((s) => {
    const d = new Date(`${s}T12:00:00Z`);
    return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s;
  }, 'Not a calendar date');

export const ChoreInstancesQuerySchema = z.object({
  date: OsloDateSchema.optional(),
});

export type ChoreInstancesQuery = z.infer<typeof ChoreInstancesQuerySchema>;
